import { render, staticRenderFns } from "./SuggestionBox.vue?vue&type=template&id=5f14c70e&scoped=true"
import script from "./SuggestionBox.vue?vue&type=script&lang=js"
export * from "./SuggestionBox.vue?vue&type=script&lang=js"
import style0 from "./SuggestionBox.vue?vue&type=style&index=0&id=5f14c70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f14c70e",
  null
  
)

export default component.exports